import Icon from 'veui/components/Icon'
import { IconUserBookmark } from 'dls-icons-vue'

Icon.register('user-bookmark', IconUserBookmark)
